module.exports = __webpack_public_path__ + "static/misc-banner-838848533665d6d1f513f2bac817e6ac.png";